import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import Paper from '@material-ui/core/Paper';
import {withRouter} from "react-router-dom";
import AddCircle from '@material-ui/icons/AddCircleOutline';
import { inject, observer } from 'mobx-react';
import _ from 'lodash'
import {pending} from '../stores/State'

@inject('store')
@observer
class Customers extends Component {
  componentDidMount(){
    this.fetchData();
  }
  componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props, nextProps)) this.fetchData(nextProps.customerId);
  }
  
  fetchData(accountId){
    const store  = this.props.store.customerStore;
    store.fetchAccountCustomers(accountId || this.props.accountId)
  }

  handleRowClick(customer){
    this.props.history.push(`/customers/${customer.id}`);    
  }

  render() {
    const { classes } = this.props;
    const store  = this.props.store.customerStore;
    
    return (
      <Paper className={classes.paper}>
        <Typography variant='subheading'>
          Customers 
        </Typography>
        { store.customersState === pending && <CircularProgress /> }
        { store.customers && 
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Inventory locations</TableCell>
                <TableCell>Total capacity</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {store.customers.map(customer => {
                return (
                  <TableRow key={customer.id} hover onClick={()=>this.handleRowClick(customer)}>
                    <TableCell>{customer.name}</TableCell>
                    <TableCell>{customer.inventory_locations_count}</TableCell>
                    <TableCell>{customer.total_capacity} units</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell colSpan="3">
                  <Button size="small" className={classes.button} variant="contained" color='primary' onClick={()=>this.props.history.push(`/accounts/${this.props.accountId}/customers/new`)}>New customer<AddCircle className={classes.icon}/></Button>
                </TableCell>
                </TableRow>
            </TableFooter>
          </Table> }
        </Paper>
    );
  }
}

const styles = theme => ({
  paper: {
    padding: 20
  },
  button:{
    margin: 5
  },
  icon:{
    marginLeft: 5
  }
});

Customers.propTypes = {
  accountId: PropTypes.number
}

export default withRouter(withStyles(styles)(Customers));



// WEBPACK FOOTER //
// ./src/components/Customers.js